import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'lib-mapfre-design-library',
//   template: `
//     <p>
//       mapfre-design-library works!
//     </p>
//   `,
//   styles: []
// })
// export class MapfreDesignLibraryComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }


import { Component, OnInit } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { Language } from './app.language';
import * as _ from 'underscore';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'lib-mapfre-design-library',
  template: `
    <p>
      mapfre-design-library works!
    </p>
  `,
})
export class MapfreDesignLibraryComponent implements OnInit {
  title = "Mapfre Insurance";
  constructor(public translate: TranslateService, public _languages: Language) { }

  findLanguage(): void {
    // Created variable for get default language stored in localstorage
    const localStorageLang = localStorage.getItem('defaultUserLanguage')
    // Set conditionally localstorage language when it found else set navigator language
    let lang = localStorageLang ? localStorageLang : navigator.language;

    lang = (lang.indexOf("-") !== -1) ?
      lang.slice(0, lang.indexOf("-")).toUpperCase() :
      lang.toUpperCase();

    _.each(this._languages['lang'], function (val) {
      this.translate.setTranslation(val['identifier'], val['sentences']);
    })
    this.translate.setDefaultLang('EN');
    this.setLang(lang);
  }

  setLang(lang: string): void {
    this.translate.use(lang);
  }



  ngOnInit() {
    this.findLanguage();
  }

}
